<div class="flex items-center justify-center min-h-screen">
  <div class="w-[800px] h-[400px] border rounded p-6 bg-slate-200">
    <h1 class="text-2xl font-bold">Download Jackpot Assets ...</h1>
    <div class="flex items-center justify-center h-[100%] w-[100%]">
      <div *ngIf="errors.length > 0" class="text-red-500">
        <h2 class="text-2xl">Fehler</h2>
        <div *ngFor="let error of errors">{{ error }}</div>
      </div>
      <div *ngIf="errors.length === 0">
        <div *ngIf="info && !prepare" class="flex flex-col items-center">
          <div class="mb-4">
            <span *ngIf="info.info">
              Klasse 1: {{ info.info.klasse1 | number : '1.0-0' }} | Klasse 2: {{ info.info.klasse2 | number : '1.0-0' }} | Annahmeschluss:
              {{ info.info.annahmeschluss | date : "dd.MM.yyyy 'um' HH:mm 'Uhr'" }}
            </span>
          </div>
          <div *ngIf="info.count === 0">Keine Dateien für die Auswahl vorhanden</div>
          <div *ngIf="info.count > 0">
            <button mat-flat-button color="primary" class="button-primary" (click)="prepareDownload()">Download ZIP erstellen</button>
          </div>
        </div>

        <div *ngIf="prepare && !downloaded" class="flex flex-col items-center">
          <h2 class="mb-4">Download wird vorbereitet ...</h2>
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
        <div *ngIf="downloaded?.totalFiles === 0">Keine Dateien gefunden :-(</div>
        <div *ngIf="downloaded" class="flex flex-col items-center">
          <div *ngIf="downloaded.totalFiles > 0">Es werden {{ downloaded.totalFiles }} Dateien als ZIP heruntergeladen.</div>
          <div *ngIf="downloaded.downloads && downloaded.downloads.length > 1">Anhand der Größe müssen {{ downloaded.downloads.length }} ZIP Dateien geladen werden.</div>
          <div *ngIf="downloaded.downloads && downloaded.downloads.length === 1">
            <div *ngFor="let download of downloaded.downloads" class="mt-4">
              <button mat-flat-button color="primary" class="button-primary" (click)="downloadZip(download)">Download ZIP</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
